import { render, staticRenderFns } from "./download-table.component.vue?vue&type=template&id=1c0b5ea2&scoped=true&"
import script from "./download-table.component.vue?vue&type=script&lang=tsx&"
export * from "./download-table.component.vue?vue&type=script&lang=tsx&"
import style0 from "./download-table.component.vue?vue&type=style&index=0&id=1c0b5ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b5ea2",
  null
  
)

export default component.exports